export default __webpack_public_path__ + "static/media/Discover.bb3c4fd2.svg";